module.exports = __webpack_public_path__ + "static/img/bystage_white_03.bcb7e01a.svg";